import { render, staticRenderFns } from "./ed-class-schedule-hours.component.vue?vue&type=template&id=209f8f46&scoped=true&"
import script from "./ed-class-schedule-hours.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-hours.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-hours.component.scss?vue&type=style&index=0&id=209f8f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f8f46",
  null
  
)

export default component.exports